import { gql } from "@apollo/client";

export const deleteLensMutation = gql`
    mutation deleteLens($lensId: ID!) {
        deleteLens(input: { lensId: $lensId })
    }
`;
